import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Snow = class Snow extends Vue {
};
Snow = __decorate([
    Component({
        data() {
            return {};
        },
    })
], Snow);
export default Snow;
